import { defineStore } from 'pinia'

export const useTempStore = defineStore('temp', {
  state: () => ({
    forgotpasswordemail: null,
  }),
  actions: {
    setForgotPasswordEmail(val: string) {
      // @ts-expect-error
      this.forgotpasswordemail = val
    },
  },
})
